// Plugins
import "bootstrap/dist/js/bootstrap";

// Funciones
import "./helpers";

// Components
import "./components/inputPassword";
import "./components/selectLang";
import "./components/selectRole";
import "./components/selectCategory";
import "./components/selectSimple";
import "./components/changeStatus";
import "./components/changeFront";
import "./components/changeMenu";
import "./components/deleteButton";
import "./components/inputImage";
import "./plugins/tinymce";

// Enrutamiento del JavaScript
const imports = {
    layout: require("./views/layout"),
    loginPage: require("./views/login/login"),
    dashboard: require("./views/dashboard/dashboard"),
    menu: require("./views/sections/menu"),
    languages: require("./views/settings/settings/languages/languages"),
    storeLanguage: require("./views/settings/settings/languages/modals/store"),
    companies: require("./views/settings/settings/companies/companies"),
    users: require("./views/settings/access/users/users"),
    storeUser: require("./views/settings/access/users/modals/store"),
    roles: require("./views/settings/access/roles/roles"),
    storeRole: require("./views/settings/access/roles/modals/store"),
    modules: require("./views/settings/access/modules/modules"),
    storeModule: require("./views/settings/access/modules/modals/store"),
    categories: require("./views/admin/blog/categories/categories"),
    storeCategory: require("./views/admin/blog/categories/modals/store"),
    infoCategories: require("./views/admin/blog/categories/infoCategories"),
    posts: require("./views/admin/blog/posts/posts"),
    storePost: require("./views/admin/blog/posts/modals/store"),
    xx: require("./views/admin/blog/x/x"),
    storeX: require("./views/admin/blog/x/modals/store"),
    infographics: require("./views/admin/infographics/infographics"),
    storeInfographic: require("./views/admin/infographics/modals/store"),
    memes: require("./views/admin/memes/memes"),
    storeMeme: require("./views/admin/memes/modals/store"),
    videos: require("./views/admin/videos/videos"),
    storeVideo: require("./views/admin/videos/modals/store"),
    playVideo: require("./views/admin/videos/modals/play"),
    headers: require("./views/admin/headers/headers"),
    rss: require("./views/admin/rss/rss"),
    storeRss: require("./views/admin/rss/modals/store"),
    comments: require("./views/admin/blog/comments/comments"),
};

const Element = document.querySelectorAll("[data-current-section]");

export const loadFunction = () => {
    // console.log("backend");
    Element.forEach((element) => {
        if (element) {
            let functionName = element.getAttribute("data-current-section");

            if (functionName in imports) {
                imports[functionName][functionName]();
            }
        }
    });
};

loadFunction();
